import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=b0a5aed4&scoped=true&"
var script = {}
import style0 from "./Remove.vue?vue&type=style&index=0&id=b0a5aed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a5aed4",
  null
  
)

export default component.exports